import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IPricingBatch } from "../interface/IPricingBatch";
import { IUpdateTradesInPricingBatch } from "../interface/entuba/pricing/IUpdateTradesInPricingBatch";
import { IBaseResponse } from "../interface/IBaseResponse";
import { IReprocessEntubaPricingBatch } from '../interface/entuba/IReprocessEntubaPricingBatch';

enum PricingBatchServiceEnum {
  getAll = "/",
  getDetail = "",
  start = "/start",
  reprocess = "/reprocess",
  update = "/update",
  getPricingTradesFinished = "/get-pricing-trades-finished",
  updateTrades = "/update-trades"
}

export default class PricingBatchService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/batch/pricing");
  }

  public startPricingBatch = async data => await this.PUT(PricingBatchServiceEnum.start, data);
  public updatePricingBatch = async data => await this.PUT(PricingBatchServiceEnum.update, data);
  public reprocessPricingBatch = async (data: IReprocessEntubaPricingBatch) => await this.PUT(PricingBatchServiceEnum.reprocess, data);
  public getAll = async (): Promise<IPricingBatch[]> => await this.GET(PricingBatchServiceEnum.getAll);

  public getPricingTradesFinished = async (id: number): Promise<number[]> => await this.GET(`${PricingBatchServiceEnum.getPricingTradesFinished}/${id}`);
  public updateTrades = async (request: IUpdateTradesInPricingBatch): Promise<IBaseResponse> => await this.POST(PricingBatchServiceEnum.updateTrades, request);

  public getDetail = async idBatch => {
    const data = await this.GET(`${PricingBatchServiceEnum.getDetail}/${idBatch}`);
    return data;
  };
}
